export function hotelContentToText(value?: string) {
  if (!value) return "";

  return cleanHotelContentText(
    decodeHotelContentEntities(value)
    .replace(/<br\s*\/?>/gi, "\n")
    .replace(/<li[^>]*>/gi, "• ")
    .replace(/<\/(p|div|li|h[1-6])>/gi, "\n")
    .replace(/<[^>]+>/g, " "),
  );
}

export function hotelContentToHtml(value?: string) {
  if (!value) return "";

  return cleanHotelContentHtml(
    decodeHotelContentEntities(value)
      .replace(/<script[\s\S]*?<\/script>/gi, "")
      .replace(/<style[\s\S]*?<\/style>/gi, "")
      .replace(/\son\w+=(?:"[^"]*"|'[^']*'|[^\s>]+)/gi, "")
      .replace(/\s(?:style|class|id)=(?:"[^"]*"|'[^']*'|[^\s>]+)/gi, "")
      .replace(/href\s*=\s*(['"])\s*javascript:[\s\S]*?\1/gi, "")
      .replace(/<a\b([^>]*)>/gi, (_match, attributes: string) =>
        createSafeLinkTag(attributes),
      )
      .replace(
        /<\/?(?!p|br|h[1-6]|ul|ol|li|strong|b|em|i|a|table|thead|tbody|tr|th|td|div)\b[^>]*>/gi,
        " ",
      ),
  );
}

function createSafeLinkTag(attributes: string) {
  const href = getAttributeValue(attributes, "href");
  if (!href || !isSafeLink(href)) return "<a>";

  const target = getAttributeValue(attributes, "target");
  const targetAttributes = target === "_blank" ? ' target="_blank" rel="noopener noreferrer"' : "";

  return `<a href="${escapeHtmlAttribute(href)}"${targetAttributes}>`;
}

function getAttributeValue(attributes: string, attribute: string) {
  const expression = new RegExp(
    `\\b${attribute}\\s*=\\s*(?:"([^"]*)"|'([^']*)'|([^\\s"'=<>\\x60]+))`,
    "i",
  );
  const match = attributes.match(expression);
  return match?.[1] ?? match?.[2] ?? match?.[3];
}

function isSafeLink(href: string) {
  const normalizedHref = decodeHotelContentEntities(href)
    .replace(/&#(x[\da-f]+|\d+);?/gi, (_match, entity: string) =>
      decodeNumericEntity(entity),
    )
    .replace(/&colon;/gi, ":")
    .replace(/[\u0000-\u0020]+/g, "");

  return /^(?:https?:|mailto:|tel:|\/|\?|#)/i.test(normalizedHref);
}

function decodeNumericEntity(entity: string) {
  const isHex = entity[0]?.toLowerCase() === "x";
  const codePoint = Number.parseInt(isHex ? entity.slice(1) : entity, isHex ? 16 : 10);

  return Number.isSafeInteger(codePoint) && codePoint <= 0x10ffff
    ? String.fromCodePoint(codePoint)
    : "";
}

function escapeHtmlAttribute(value: string) {
  return value
    .replace(/&/g, "&amp;")
    .replace(/"/g, "&quot;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

export function cleanHotelContentText(value: string) {
  return decodeHotelContentEntities(value)
    .replace(/[ \t]+\n/g, "\n")
    .replace(/[ \t]+/g, " ")
    .replace(/\n\s*\n+/g, "\n")
    .trim();
}

function cleanHotelContentHtml(value: string) {
  return value
    .replace(/<(p|div|li|h[1-6]|td|th)>\s*/gi, "<$1>")
    .replace(/\s*<\/(p|div|li|h[1-6]|td|th)>/gi, "</$1>")
    .replace(/>\s+</g, "><")
    .trim();
}

function decodeHotelContentEntities(value: string) {
  return value
    .replace(/&nbsp;/gi, " ")
    .replace(/&zwnj;|zwnj;|zwnj/gi, "\u200c")
    .replace(/&amp;/gi, "&")
    .replace(/&quot;/gi, '"')
    .replace(/&#39;|&apos;/gi, "'")
    .replace(/&lt;/gi, "<")
    .replace(/&gt;/gi, ">");
}
